import { Checkbox, Col, Divider, Form, Row, Typography, InputNumber } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import TimeInput from './TimeInput/TimeInput';
import "./style.css";

const { Text } = Typography;

const AdvancedControl = () => {
    const { t } = useTranslation();

    return (
        <>
            <Col span={24}>
                <div className="section">
                    <Text style={{ color: '#1677ff', fontSize: '16px', fontWeight: 'bold', marginBottom: '12px', display: 'block' }}>{t('advanced.analysis_settings')}</Text>
                    <Row gutter={[16, 0]} align="middle">
                        <Col xs={24} md={6}>
                            <Form.Item style={{ marginBottom: 0 }} name="analyzeImage" valuePropName="checked"
                                labelCol={{ style: { paddingBottom: 0 } }}>
                                <Checkbox data-tour="adv-analysis">{t('advanced.image_analysis')}</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={6}>
                            <Form.Item style={{ marginBottom: 0 }} name="analyzeVideo" valuePropName="checked"
                                labelCol={{ style: { paddingBottom: 0 } }}>
                                <Checkbox>{t('advanced.video_analysis')}</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={6}>
                            <Form.Item style={{ marginBottom: 0 }} name="analyzeAudio" valuePropName="checked"
                                labelCol={{ style: { paddingBottom: 0 } }}>
                                <Checkbox>{t('advanced.audio_analysis')}</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={6}>
                            <Form.Item style={{ marginBottom: 0 }} name="analyzeDocument" valuePropName="checked"
                                labelCol={{ style: { paddingBottom: 0 } }}>
                                <Checkbox>{t('advanced.document_analysis')}</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
            </Col>
            
            <Divider style={{ margin: '16px 0' }} />
            
            <Col span={24}>
                <div className="section">
                    <Text style={{ color: '#1677ff', fontSize: '16px', fontWeight: 'bold', marginBottom: '12px', display: 'block' }}>{t('advanced.consumption_settings')}</Text>
                    <Row gutter={[16, 0]} align="middle">
                        <Col xs={24} md={6}>
                            <Form.Item style={{ marginBottom: 0 }} name="is_consumption_limit_enabled" valuePropName="checked" initialValue={true} label={t('advanced.enable_limit')}
                                labelCol={{ style: { paddingBottom: 4 } }}>
                                <Checkbox data-tour="adv-consumption" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={6}>
                            <Form.Item style={{ marginBottom: 0 }}
                                name="max_coins_consumption"
                                label={t('advanced.max_coins')}
                                labelCol={{ style: { paddingBottom: 4 } }}
                            >
                                <InputNumber
                                    style={{ width: '100%' }}
                                    type='number'
                                    min={1}
                                    disabled={!Form.useWatch('is_consumption_limit_enabled', Form.useFormInstance())}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={6}>
                            <Form.Item style={{ marginBottom: 0 }}
                                name="consumption_duration"
                                label={t('advanced.duration')}
                                labelCol={{ style: { paddingBottom: 4 } }}
                            >
                                <TimeInput
                                    style={{ width: '100%' }}
                                    min={1}
                                    defaultUnit="hours"
                                    disabled={!Form.useWatch('is_consumption_limit_enabled', Form.useFormInstance())}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={6}>
                            <Form.Item
                                name="snooze_duration"
                                label={t('advanced.snooze')}
                                style={{ marginBottom: 0 }}
                                labelCol={{ style: { paddingBottom: 4 } }}
                            >
                                <TimeInput
                                    style={{ width: '100%' }}
                                    min={1}
                                    defaultUnit="minutes"
                                    disabled={!Form.useWatch('is_consumption_limit_enabled', Form.useFormInstance())}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
            </Col>
            
            <Divider style={{ margin: '16px 0' }} />
            
            <Col span={24}>
                <div className="section">
                    <Text style={{ color: '#1677ff', fontSize: '16px', fontWeight: 'bold', marginBottom: '12px', display: 'block' }}>{t('advanced.processing_settings')}</Text>
                    <Row gutter={[16, 0]} align="middle">
                        <Col xs={24} md={6}>
                            <Form.Item style={{ marginBottom: 0 }}
                                name="is_processing_delay_enabled"
                                valuePropName="checked"
                                initialValue={true}
                                label={t('advanced.enable_delay')}
                                labelCol={{ style: { paddingBottom: 4 } }}>
                                <Checkbox data-tour="adv-processing" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={9}>
                            <Form.Item style={{ marginBottom: 0 }}
                                name="processing_delay"
                                label={t('advanced.delay')}
                                labelCol={{ style: { paddingBottom: 4 } }}
                            >
                                <TimeInput
                                    style={{ width: '100%' }}
                                    min={1}
                                    max={30}
                                    defaultUnit="seconds"
                                    allowedUnits={['seconds']}
                                    disabled={!Form.useWatch('is_processing_delay_enabled', Form.useFormInstance())}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={9}>
                            <Form.Item
                                style={{ marginBottom: 0 }}
                                name="processing_jitter"
                                label={t('advanced.jitter_percentage')}
                                labelCol={{ style: { paddingBottom: 4 } }}
                            >
                                <InputNumber
                                    style={{ width: '100%' }}
                                    type='number'
                                    min={1}
                                    max={100}
                                    disabled={!Form.useWatch('is_processing_delay_enabled', Form.useFormInstance())}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
            </Col>
            
            <Divider style={{ margin: '16px 0' }} />
            
            <Col span={24}>
                <div className="section">
                    <Text style={{ color: '#1677ff', fontSize: '16px', fontWeight: 'bold', marginBottom: '12px', display: 'block' }}>{t('advanced.escalation_settings')}</Text>
                    <Row gutter={[16, 0]} align="middle">
                        <Col xs={24} md={6}>
                            <Form.Item style={{ marginBottom: 0 }} name="allow_escalation" valuePropName="checked"
                                labelCol={{ style: { paddingBottom: 0 } }}>
                                <Checkbox data-tour="adv-escalation">{t('advanced.allow_escalation')}</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
            </Col>
        </>
    );
};

export default AdvancedControl;
